import { render } from "./Works.vue?vue&type=template&id=62b581d6&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=62b581d6&scoped=true&lang=css"

import exportComponent from "/Users/hk/Omat tiedostot/koodit/htmljacss/hkvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b581d6"]])

export default __exports__